import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface Order {
  proposalId: string
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
  setProposalId: (proposalId: string) => void
}

const useStoreBase = create<Order>()((set) => ({
  proposalId: '',
  isModalOpen: false,
  setModalOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setProposalId: (proposalId: string) => set(() => ({ proposalId }))
}))

export const useProofPaymentStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
